import { getOrderReminder } from "@TKCCP/Services/tkccpOrderReminderService";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import {OrderEmailScheduleModel } from "@TKCCP/Types/ApiModels";

type HandlerType = Handler<
    {
        orderNumber: string;
    },
    {
        orderEmailScheduleModel?: OrderEmailScheduleModel;
    }
>;

const isNotFoundResponse = (error: any) => error && error.status === 404;

export const DispatchBeginLoadOrderReminder: HandlerType = props => {
    props.dispatch({
        
        type: "Data/OrderReminder/BeginLoadOrderReminder" as any,
        orderNumber: props.parameter.orderNumber,
    });
};

export const GetOrderReminder: HandlerType = async props => {
    try {
        props.orderEmailScheduleModel = await getOrderReminder({ orderNumber: props.parameter.orderNumber,cartId: "",orderEmailScheduleModel:{} as OrderEmailScheduleModel });
        
    } catch (error) {
        if (isNotFoundResponse(error)) {
            logger.info(`The order with order number "${props.parameter.orderNumber}" does not have order schedular data.`);
        } else {
            throw error;
        }
    }
};

export const DispatchCompleteLoadOrderReminder: HandlerType = props => {
    
    props.dispatch({
        type: "Data/OrderReminder/CompleteLoadOrderReminder" as any,
        orderNumber: props.parameter.orderNumber,
        model: props.orderEmailScheduleModel as any,
    });
};

export const chain = [DispatchBeginLoadOrderReminder, GetOrderReminder, DispatchCompleteLoadOrderReminder];

const loadOrderReminder = createHandlerChainRunner(chain, "LoadOrderReminder");
export default loadOrderReminder;
